<template lang="pug">
.integration-provider
  BriqMultiselect(
    v-model="integrationProvider"
    :options="externalTypeOptions"
    :disabled="disabled"
    label="Integration Provider"
    display="DisplayName"
    data-test-id="integration-provider-multiselect"
    )
</template>

<script>
export default {
  name: 'IntegrationProviderField',
  props: {
    buKey: String,
    value: String,
    disabled: Boolean,
    externalTypes: {
      type: Array,
      required: true,
    },
  },
  computed: {
    externalTypeOptions() {
      return this.externalTypes.map(externalType => ({
        DisplayName: externalType.DisplayName,
        Name: externalType.ExternalType,
      }))
    },
    integrationProvider: {
      get() {
        return this.externalTypeOptions.find(o => o.Name === this.value)
      },
      set(v) {
        const isNew = v?.Name !== this.value
        if (isNew) this.$emit('integrationProviderSelected', v?.Name || null)
      },
    },
  },
}
</script>
